/**
 * 日本語の locale。読み上げスクリプトは音素カバレッジを意識した固定セット。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business 日本語 UI 文言と読み上げスクリプト 3 文の locale bundle
 * @graph-connects none
 */

import type { LocaleBundle } from './types.js';

/** @graph-connects none */
export const ja: LocaleBundle = {
  messages: {
    appTitle: '声紋登録',
    consent: {
      title: '同意事項',
      summary:
        '声紋登録は Meet 録画の話者識別を改善するためのものです。以下の取り扱いに同意の上ご利用ください。',
      items: [
        '録音した音声は声紋特徴量（embedding）の計算にのみ使用します。',
        '元音声は GCS に 30 日間保管後に自動削除します。声紋特徴量はあなたが削除を依頼するまで保持されます。',
        'いつでも自分の声紋データの削除を依頼できます。',
        '本データは社外には提供されません。社内の話者識別パイプラインからのみ参照されます。',
      ],
      agreeLabel: '同意して進む',
      declineLabel: 'キャンセル',
    },
    languageSelect: {
      title: '言語を選んでください',
      description:
        '会議で主に使う言語の声紋を登録します。複数言語を使う場合は、後でこの画面から追加登録できます。',
      languageNames: {
        ja: '日本語',
        en: 'English',
        vi: 'Tiếng Việt',
      },
      confirm: '次へ',
    },
    recording: {
      title: '読み上げ録音',
      instruction:
        '画面に表示される文章を、普段の声で自然に読み上げてください。静かな場所で、マイクから 30cm 以内を目安に。',
      progressLabel: '録音中…',
      startLabel: '録音開始',
      stopLabel: '録音停止',
      retakeLabel: '録り直す',
      nextLabel: '次の文章へ',
      submitLabel: '登録する',
      qualityIssue: '音声品質に問題があります',
      qualityHint:
        '録音時間が短すぎる、音量が低すぎる、無音が多い、いずれかの可能性があります。もう一度お試しください。',
      recordHint: 'タップして録音',
      checkHint: 'タップして確認',
      readyHint: '✓ 確認済み',
      retryHint: '⚠ 録り直してください',
    },
    result: {
      successTitle: '登録が完了しました',
      successDescription:
        'これで Meet 録画の文字起こしであなたの発話が実名で識別されるようになります。',
      failureTitle: '登録に失敗しました',
      failureDescription:
        'サーバーエラーが発生しました。時間をおいて再度お試しください。問題が続く場合は管理者までご連絡ください。',
      backLabel: '最初から',
    },
  },
  readingScripts: [
    {
      id: 'ja-1',
      text: '今日は朝からカフェラテを二杯飲んで、新作ワンピースの展示会に行ってきました。生地の手触りがすごく良くて、思わず三着も試着しちゃいました。',
      estimatedSeconds: 12,
    },
    {
      id: 'ja-2',
      text: '週末は鎌倉の海沿いを散歩したい気分です。波の音を聞きながら、季節の変わり目に着られそうな軽いコートを選びたいなと思っています。',
      estimatedSeconds: 11,
    },
    {
      id: 'ja-3',
      text: '好きな食べ物は、塩バターラーメンと熟成チーズと、あったかい焼き芋。ちょっと欲張りすぎかもしれないけど、どれも譲れないんです。',
      estimatedSeconds: 11,
    },
  ],
};
